function stripCurrencyFromComparePrice() {
  document.querySelectorAll('.compare-price:not([data-stripped])').forEach(function (el) {
    el.textContent = el.textContent.replace(/Rs\.?\s*/g, '').trim();
    el.dataset.stripped = 'true';
  });
}

function shrinkCurrencyInRegularPrice() {
  document.querySelectorAll('.price--special:not([data-currency-wrapped])').forEach(function (el) {
    var text = el.textContent.trim();
    var match = text.match(/^(Rs\.?\s*)(.*)$/);
    if (match) {
      el.innerHTML = '<span class="currency-small">' + match[1] + '</span>' + match[2];
      el.dataset.currencyWrapped = 'true';
    }
  });
}

function runAll() {
  stripCurrencyFromComparePrice();
  shrinkCurrencyInRegularPrice();
}

document.addEventListener('DOMContentLoaded', runAll);

// Debounce: turant nahi, thoda ruk ke chalao — taake barabar wale mutations ek baar mein handle ho jayein
var debounceTimer;
function scheduleRun() {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(runAll, 150);
}

var observer = new MutationObserver(function (mutations) {
  // Sirf tab react karo jab actual naye text nodes ya elements add hue hon
  // (attribute-only ya humare khud ke innerHTML se hue changes ignore karo)
  var relevant = mutations.some(function (m) {
    if (m.type !== 'childList') return false;
    for (var i = 0; i < m.addedNodes.length; i++) {
      var node = m.addedNodes[i];
      if (node.nodeType === 1 && (
          node.matches?.('.compare-price, .price--special') ||
          node.querySelector?.('.compare-price, .price--special')
      )) {
        return true;
      }
    }
    return false;
  });
  if (relevant) scheduleRun();
});

var observeTarget = document.getElementById('MainContent') || document.body;
observer.observe(observeTarget, { childList: true, subtree: true });